<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<textarea
			[ariaLabel]="title()"
			[class.large]="height() === 'large'"
			[class.with-action-bar]="showActionBar()"
			[ngClass]="inputDesignClass()"
			#input
			[placeholder]="placeholder()"
			[attr.maxLength]="maxLength()"
			[ngModel]="lastValidValue()"
			(ngModelChange)="handleModelChange($event)"
		></textarea>

		@if (showActionBar()) {
		<div class="ui-text-area-action-bar">
			<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
				@if (enableGenAiCalculated()) {
				<div libFlexColumn [libFlexSize]="undefined">
					<a (click)="handleAskAi()"> Ask AI </a>
				</div>
				} @if (enableSnippetCalculated()) {
				<div libFlexColumn [libFlexSize]="undefined">
					<a (click)="handleSelectSnippet()"> Copy snippet </a>
				</div>
				} @if (enableEmojiCalculated()) {
				<div libFlexColumn [libFlexSize]="undefined">
					<div>
						<div>
							<a (click)="showEmojiSelector.set(!showEmojiSelector())">
								{{ showEmojiSelector() ? 'Hide' : 'Emoji' }}
							</a>
						</div>
					</div>
				</div>
				}
			</div>

			@if (showEmojiSelector()) {
			<div class="push-top-sm">
				<ui-emoji-selector (selectEmoji)="handleSelectEmoji($event)"></ui-emoji-selector>
			</div>
			}
		</div>
		}
	</div>
</ui-form-field-layout>
